import { render, staticRenderFns } from "./ContactCards.vue?vue&type=template&id=0262d5fb&%23default=true&v-slot=%7Bset%7D&"
import script from "./ContactCards.vue?vue&type=script&lang=js&"
export * from "./ContactCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports